module.exports = __webpack_public_path__ + "static/media/delivery icon 2.1d42158a.png";